'use strict';

module.exports = /* @ngInject */ ["authApiFactory", function (authApiFactory) {
  this.get = function (eikonToken) {
    return authApiFactory.create().then(function (api) {
      return api.one('eikonsso')
          .one('heartbeat')
          .withHttpConfig({ignoreAuthModule: true})
          .get(null, {'Eikon-Token': eikonToken});
    });
  };
}];



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/business/eikonHeartbeatRepository.js
// module id = 121
// module chunks = 0